import React from 'react';
import _ from 'lodash';

import { SpotWorkerHeader } from '../header/SpotWorkerHeader';
import { SpotWorkerImageForm } from '../form/SpotWorkerImageForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { extractErrorMessage } from '../../../utilities/commonUtil';
import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import {
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  FACE_PICTURE_UPLOAD_STATUS,
  SPOT_WORKER_TAB,
} from '../../../utilities/constants';
import SpotWorkersService from '../../../services/spotWorkers/SpotWorkersService';
import SpotWorkersApi from '../../../services/spotWorkers/SpotWorkersApi';

/**
 * 現場常駐社員・非常駐入退場者顔写真ページ
 * @props {object}pageStatus:ページ情報 (詳細・編集)
 */
export class SpotWorkerImage extends React.Component {
  state = {
    header: {
      // 現場常駐社員・非常駐入退場者基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 現場常駐社員・非常駐入退場者一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    workerImage: {
      imageUrl: '',
      imageBinary: null,
      imageName: '',
      uploadStatus: FACE_PICTURE_UPLOAD_STATUS.notChangedFile.id,
      isInitFile: false,
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
  };

  events = {};

  constructor(props) {
    super(props);

    this.updatingFlag = false; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT
      )
    ) {
      throw new Error('WorkerImage.jsx constructor props.pageStatus');
    }

    // SpotWorkerImage.jsxに渡すイベント
    this.events.setValueWorkerImage = this.setValueWorkerImage.bind(this);

    this.state.spotWorkerInfo = this.props.spotWorkerInfo;
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  componentDidMount() {
    this.setState(state => {
      state.workerImage.imageUrl =
        state.spotWorkerInfo.worker_thumbnail_image_url;
      state = this.createObjectForMoveToWorkerList(state);
      return state;
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.spotWorkerInfo != this.props.spotWorkerInfo) {
      let state = _.cloneDeep(this.state);
      state.spotWorkerInfo = nextProps.spotWorkerInfo;
      state.workerImage.imageUrl =
        state.spotWorkerInfo.worker_thumbnail_image_url;
      state = this.createObjectForMoveToWorkerList(state);
      this.setState(state);
    }
  }

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 現場常駐社員・非常駐入退場者一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    const listName =
      state.spotWorkerInfo.worker_type >= 2 ? '非常駐入退場者' : '現場常駐社員';
    state.headerButtonObject.label = listName + data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.isSetDisabled = true;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.updateWorkerImage.bind(this);
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 現場常駐社員・非常駐入退場者一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 現場常駐社員・非常駐入退場者一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.close();
    location.reload();
  };

  /**
   * 顔写真詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    masterSlideLoader.show('SpotWorkerConfirm', {
      state: {
        id: `${SPOT_WORKER_TAB.FACE_IMAGE.ID},${
          this.state.spotWorkerInfo.field_spot_worker_id
        }`,
      },
    });
  };

  /**
   * 顔写真編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    masterSlideLoader.show('SpotWorkerEdit', {
      state: {
        id: `${SPOT_WORKER_TAB.FACE_IMAGE.ID},${
          this.state.spotWorkerInfo.field_spot_worker_id
        }`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  /**
   * 現場常駐社員・非常駐入退場者顔写真登録・更新
   */
  updateWorkerImage() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = { ...this.state };
    const formData = SpotWorkersService.createUpdateFacePicture(
      Object.assign(state.workerImage, {
        fieldSpotWorkerId: this.state.spotWorkerInfo.field_spot_worker_id,
      })
    );
    SpotWorkersApi.updateFacePicture(formData)
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          this.moveToWorkerConfirm();
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(response);
        this.setState(state);
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.setState(state);
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 顔写真情報をセット
   */
  setValueWorkerImage(value) {
    if (isNullOrUndefinedOrEmptyStr(value) === false) {
      const state = _.cloneDeep(this.state);
      if (value.imageUrl !== null) {
        state.workerImage.imageUrl = value.imageUrl;
      }
      if (value.imageBinary !== null) {
        state.workerImage.imageBinary = value.imageBinary;
      }
      if (value.imageName !== null) {
        state.workerImage.imageName = value.imageName;
      }
      if (value.isInitFile !== null) {
        state.workerImage.isInitFile = value.isInitFile;
      }
      state.workerImage.uploadStatus = value.uploadStatus;
      this.setState(state);
    }
  }

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <SpotWorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={0}
          isDisabled={this.state.workerImage.isInitFile}
        />
        <div className='contruction-detail-view__bar' />
        <div
          style={{ marginLeft: '22px', marginTop: '18px', fontSize: '14px' }}
        >
          {data.pageExplanation}
        </div>
        <SpotWorkerImageForm
          events={this.events}
          workerImage={this.state.workerImage}
          showEditButton={
            this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
          }
          showDeleteButton={
            this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
          }
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.closeDialog()}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
  pageExplanation: '入退場管理の顔認証で使用する画像を登録できます。',
};



// WEBPACK FOOTER //
// ./src/components/spotWorker/page/SpotWorkerImage.jsx